// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plant-bar {
  position: sticky;
    font-size: 18px;
    background: white;
    width: 349px;
    left: 0px;
    top: -12px;
    height: 46px;
    margin-left: -4px;
    z-index: 999;
}

.plant-bar::before {
  content: "";
  width: 352px;
  height: 10px;
  background: white;
  display: block;
}

.plant-id,
.plant-name {
  font-weight: bold;
}

.plant-id {
  padding-left: 15px;
}

.time-bar {
  height: 34px;
  background: #dfdede;
}

.time-bar:before {
  display: block;
  width: 100%;
  background: #4a4a4a;
  height: 3px;
  content: "";
  position: relative;
  z-index: 100;
  top: -3px;
}

.plant-time {
  border-radius: 100px;
  color: #4a4a4a;
  padding: 2px 8px 2px 8px;
  font-weight: bold;
  top: 3px;
  left: 4px;
  position: relative;
}

.column-container {
  white-space: nowrap;
  width: 1380px;
  overflow-x: hidden;
  margin: 0 auto;
}

.scroll-container {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  height: calc(100vh - 130px);
}

@media only screen and (max-width: 1400px) {
  .scroll-container {
    width: calc(100vw - 30px);
  }
}

.column {
  position: relative;
  width: 340px;
  margin-left: 6px;
  margin-right: 6px;
  float: left;
  top: -12px;
  background: white;
  height: -moz-fit-content;
  height: fit-content;
}

.column-shadow {
  box-shadow: 0 0 4px #9b9b9b;
}

@media only screen and (max-width: 525px) {
  .scroll-container {
    flex-wrap: wrap;
    overflow-x: initial;
    height: auto;
  }
  .column {
    width: 100% !important;
  }
  .plant-bar {
      width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/schedule-page/schedule-page.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;IACd,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,SAAS;IACT,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,YAAY;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,sBAAsB;EACxB;EACA;MACI,WAAW;EACf;AACF","sourcesContent":[".plant-bar {\n  position: sticky;\n    font-size: 18px;\n    background: white;\n    width: 349px;\n    left: 0px;\n    top: -12px;\n    height: 46px;\n    margin-left: -4px;\n    z-index: 999;\n}\n\n.plant-bar::before {\n  content: \"\";\n  width: 352px;\n  height: 10px;\n  background: white;\n  display: block;\n}\n\n.plant-id,\n.plant-name {\n  font-weight: bold;\n}\n\n.plant-id {\n  padding-left: 15px;\n}\n\n.time-bar {\n  height: 34px;\n  background: #dfdede;\n}\n\n.time-bar:before {\n  display: block;\n  width: 100%;\n  background: #4a4a4a;\n  height: 3px;\n  content: \"\";\n  position: relative;\n  z-index: 100;\n  top: -3px;\n}\n\n.plant-time {\n  border-radius: 100px;\n  color: #4a4a4a;\n  padding: 2px 8px 2px 8px;\n  font-weight: bold;\n  top: 3px;\n  left: 4px;\n  position: relative;\n}\n\n.column-container {\n  white-space: nowrap;\n  width: 1380px;\n  overflow-x: hidden;\n  margin: 0 auto;\n}\n\n.scroll-container {\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  height: calc(100vh - 130px);\n}\n\n@media only screen and (max-width: 1400px) {\n  .scroll-container {\n    width: calc(100vw - 30px);\n  }\n}\n\n.column {\n  position: relative;\n  width: 340px;\n  margin-left: 6px;\n  margin-right: 6px;\n  float: left;\n  top: -12px;\n  background: white;\n  height: fit-content;\n}\n\n.column-shadow {\n  box-shadow: 0 0 4px #9b9b9b;\n}\n\n@media only screen and (max-width: 525px) {\n  .scroll-container {\n    flex-wrap: wrap;\n    overflow-x: initial;\n    height: auto;\n  }\n  .column {\n    width: 100% !important;\n  }\n  .plant-bar {\n      width: auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
